import { fromJS } from 'immutable';
import { types as deleteTypes } from 'reducers/entity/delete';
import { types as editTypes } from 'reducers/location/edit';

export const types = {
  SEARCH_REQUEST: 'LOCATION/LIST/SEARCH_REQUEST',
  SEARCH_SUCCESS: 'LOCATION/LIST/SEARCH_SUCCESS',
  SEARCH_FAILURE: 'LOCATION/LIST/SEARCH_FAILURE',
  RESET_ERROR: 'LOCATION/LIST/RESET_ERROR',
  DETAILS_OPEN: 'LOCATION/LIST/DETAILS_OPEN',
  DETAILS_CLOSE: 'LOCATION/LIST/DETAILS_CLOSE',
  RESET: 'LOCATION/LIST/RESET',
};

export const initialState = fromJS({
  items: null,
  paging: null,
  isFetching: false,
  isFetchingToAppend: false,
  error: false,
  detailsOpen: false,
  detailsEntity: null,
});

export default function list(state = initialState, action) {
  switch (action.type) {
    case editTypes.UPDATE_SUCCESS: {
      const { entity } = action;
      const { id } = entity;
      const items = state.get('items');
      const itemIndex = items ? items.findIndex((item) => item.get('id') === id) : -1;
      if (itemIndex !== -1) {
        return state.withMutations((s) => {
          s.set('items', items.set(itemIndex, fromJS(entity)));
        });
      }
      return state;
    }
    case deleteTypes.DELETE_SUCCESS: {
      const { entity } = action;
      const { id } = entity;
      const items = state.get('items');
      if (items && !items.isEmpty()) {
        return state.withMutations((s) => {
          s.set(
            'items',
            items.filter((item) => item.get('id') !== id)
          );
        });
      }
      return state;
    }
    case types.SEARCH_REQUEST:
      return state.withMutations((s) => {
        s.set('isFetching', true);
        s.set('isFetchingToAppend', action.append);
        if (!action.append) {
          s.set('items', null);
          s.set('paging', null);
        }
      });
    case types.SEARCH_SUCCESS:
      return state.withMutations((s) => {
        const { items, paging } = action;
        const presentCount = s.get('items') ? s.get('items').size : 0;
        if (items.length === 0) {
          paging.count = presentCount;
        }
        s.set('isFetching', false).set('paging', fromJS(paging));
        if (action.append && s.get('items')) {
          s.set('items', s.get('items').concat(fromJS(items)));
        } else {
          s.set('items', fromJS(items));
        }
      });
    case types.SEARCH_FAILURE:
      return state.withMutations((s) => {
        s.set('isFetching', false);
        s.set('error', true);
        if (!action.append) {
          s.set('items', null).set('paging', null);
        }
      });
    case types.RESET_ERROR:
      return state.set('error', false);
    case types.DETAILS_OPEN:
      return state.withMutations((s) => {
        s.set('detailsOpen', true);
        s.set('detailsEntity', fromJS(action.entity));
      });
    case types.DETAILS_CLOSE:
      return state.set('detailsOpen', false);
    case types.RESET:
      return initialState;
    default:
      return state;
  }
}

export const actions = {
  searchRequest: (query, sorting, append) => ({ type: types.SEARCH_REQUEST, query, sorting, append }),
  searchSuccess: (items, paging, append) => ({ type: types.SEARCH_SUCCESS, items, paging, append }),
  searchFailure: (error) => ({ type: types.SEARCH_FAILURE, error }),
  resetError: () => ({ type: types.RESET_ERROR }),
  detailsOpen: (entity) => ({ type: types.DETAILS_OPEN, entity }),
  detailsClose: () => ({ type: types.DETAILS_CLOSE }),
  reset: () => ({ type: types.RESET }),
};

export const getRoot = (state) => state.get('location').get('list');
export const getItems = (state) => getRoot(state).get('items');
export const getPaging = (state) => getRoot(state).get('paging');
export const getIsFetching = (state) => getRoot(state).get('isFetching');
export const getIsFetchingToAppend = (state) => getRoot(state).get('isFetchingToAppend');
export const getTotalMatchedCount = (state) => getPaging(state) && getPaging(state).get('count');
export const getError = (state) => getRoot(state).get('error');
export const isDetailsOpen = (state) => getRoot(state).get('detailsOpen');
export const getDetailsEntity = (state) => getRoot(state).get('detailsEntity');
